import React from 'react';
import { Link } from 'gatsby';

const LinkComponent = ({ children, ...props }) => (
  <Link {...props}>{children}</Link>
);

export default LinkComponent;
